<div class="container">

  <app-header-dialog [iconName]="'format_list_bulleted'">
    Historico Categorias
  </app-header-dialog>

  <div class='content'>

    <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Categoria</mat-label>

        <mat-select (ngModelChange)='selectCategory($event)' [errorStateMatcher]="matcher"
          [formControl]="entityForm.controls.subcategory_id">
          <mat-option *ngFor="let subcat of subcategories" [value]="subcat.id">
            {{ subcat.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="entityForm.controls.subcategory_id.hasError('required')">
          Selecione uma categoria
        </mat-error>
      </mat-form-field>

      <mat-form-field class="date-width" appearance="outline">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="pickerDate" [errorStateMatcher]="matcher"
          [formControl]="entityForm.controls.date">
        <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerDate></mat-datepicker>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]='entityForm.invalid' mat-raised-button (click)="matDialogRef.close([ 'add', entityForm ])"
      *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

    <button [disabled]='entityForm.invalid' mat-raised-button (click)="matDialogRef.close([ 'edit', entityForm ])"
      *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>